module.exports = __webpack_public_path__ + "static/media/image.867950cc.svg";